module.exports = __webpack_public_path__ + "90ffa99410ce8e575fe81d1fefbac623.png";